import { View, ViewModel } from "binder";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";

export class ProductTypeSelectorViewModel extends SelectorBaseViewModel<productType> {
    constructor(parent: ViewModel) {
        super(parent);

    }

    protected async loadData(): Promise<productType[]> {
        let productTypeList = [
            new productType(this, '1', 'محصول نهایی'),
            new productType(this, '2', 'مواد اولیه'),
            new productType(this, '3', 'کالای نیمه ساخته')
        ]
        return productTypeList;
    }

}

export class productType extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel, id: string, title: string) {
        super(parent);
        this.id = id;
        this.title = title 
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}
